"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignStorageFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var CampaignStorageFactory = /** @class */ (function (_super) {
    __extends(CampaignStorageFactory, _super);
    function CampaignStorageFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    CampaignStorageFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    CampaignStorageFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    CampaignStorageFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    CampaignStorageFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    CampaignStorageFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return CampaignStorageFactory;
}(contracts_1.ContractFactory));
exports.CampaignStorageFactory = CampaignStorageFactory;
var _abi = [
    {
        constant: true,
        inputs: [],
        name: "arcDAO",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "daoAllocation",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getRewardForDuration",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "lastUpdateTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "periodFinish",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "rewardPerTokenStored",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "rewardRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "rewardToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "rewardsDistributor",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "rewardsDuration",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "stakingToken",
        outputs: [
            {
                internalType: "contract IPermittableERC20",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tokensClaimable",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "userAllocation",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
